import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { GetUsersParams } from "./schema";

export const useGetUsers = (args: GetUsersParams | undefined) => {
  return useQuery(
    ["getUsers", args],
    async () => {
      const queryParams = new URLSearchParams();

      Object.entries(args!).forEach(([key, value]) => {
        if (value !== undefined) {
          queryParams.append(key, String(value));
        }
      });

      const response = await api.call(`/users?${queryParams.toString()}`, { root: supportApiBase });
      return response.json();
    },
    { enabled: !!args }
  );
};
